import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment-timezone';
import { Dropdown } from 'react-bootstrap';

const TimezoneDropdown = ({ setSelectedTimezone, selectedTimezone, handleInputChange }) => {

    const timezones = moment.tz.names(); // List of all timezones
    const [searchInput, setSearchInput] = useState(''); // Search input state
    const [filteredTimezones, setFilteredTimezones] = useState(timezones); // Filtered timezones
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Dropdown open state
    const searchInputRef = useRef(null); // Ref for search input

    // Set initial timezone from localStorage or default to user's timezone
    useEffect(() => {
        const storedTimezone = localStorage.getItem("selectedTimezone");
        const userTimezone = moment.tz.guess();

        if (!storedTimezone || storedTimezone === 'Select time zone') {
            localStorage.setItem("selectedTimezone", userTimezone);
            setSelectedTimezone(userTimezone);
            handleInputChange("selectedTimezone", userTimezone);
        }
    }, []); // Runs only on mount

    // Filter timezones based on search input
    useEffect(() => {
        const filtered = timezones.filter(timezone =>
            timezone.toLowerCase().includes(searchInput.toLowerCase())
        );
        setFilteredTimezones(filtered);
    }, [searchInput]); // Only depend on searchInput

    const handleSelect = (timezone) => {
        localStorage.setItem("selectedTimezone", timezone);
        handleInputChange("selectedTimezone", timezone);
        setSelectedTimezone(timezone);
    };

    return (
        <>
            <h6>Time Zone <span>*</span></h6>
            <Dropdown onToggle={(isOpen) => setIsDropdownOpen(isOpen)}>
                <Dropdown.Toggle id="dropdown-basic">
                    {selectedTimezone || "Select Timezone"}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M13.3333 8.33337L9.99996 11.6667L6.66663 8.33337" stroke="#013159" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <div className='maintextdrop'>
                        {/* Search Input */}
                        <div className='TimeZonemainsinputsssss'>
                            <input
                                type='text'
                                placeholder='Search Timezones...'
                                value={searchInput}
                                ref={searchInputRef} // Attach ref
                                onChange={(e) => setSearchInput(e.target.value)}
                                className='timeZoneInput'
                            />
                        </div>
                        {/* Filtered Timezones */}
                        <div className='timezone-list'>
                            {filteredTimezones.map((timezone, index) => (
                                <Dropdown.Item key={index} onClick={() => handleSelect(timezone)}>
                                    {timezone} ({moment.tz(timezone).format('Z')})
                                </Dropdown.Item>
                            ))}
                        </div>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </>
    );
};

export default TimezoneDropdown;